import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import CareerBlock from '../components/CareerBlock';
import SuggestedBlogs from '../components/SuggestedBlogs';
import Counter from '../components/Counter';

const About = ({
  data: {
    blog: { posts = [] },
  },
  ...props
}) => (
  <Layout {...props}>
    <SEO
      title="Building a better world, together | About Powerplay"
      description="Powerplay is a mobile collaboration app built for construction companies. From budgeting to site reporting, it helps teams work together on projects easily."
    />
    <section className="inner-hero-main">
      <div className="container">
        <div className="inner-hero-content">
          <h5>ABOUT POWERPLAY</h5>
          <h1>Building a Better World, Together.</h1>
        </div>
      </div>
      <StaticImage
        placeholder="blurred"
        src="../images/about-hero.png"
        alt="About Hero Image"
      />
    </section>
    <section>
      <div className="container">
        <div className="about-story pad100">
          <h2 className="heading inner-heading">Our Story</h2>
          <p>
            Why did a bunch of techies and product creators aimed to disrupt the
            construction business?
          </p>

          <p>
            We hear this a lot. It’s a valid question with a simple answer — we
            found a problem that we were interested in solving.{' '}
          </p>

          <p>
            My father built our house himself, allowing me to assist him when he
            added two more floors to the main building. As a perfectionist, he
            always complained when the initial time and budget estimations went
            wrong. But I didn’t understand his frustration until I decided to
            get my house renovated, and both the budget and timeline were
            exceeded by 40% — I ended up living with the carpenter and painter
            for a week!
          </p>

          <p>
            We wondered how such delays affected larger projects if smaller
            projects like ours faced so many issues. That’s when we realized
            that&nbsp;
            <strong>
              owners lose a lot of money when construction projects exceed
              budgets and timelines.
            </strong>
          </p>

          <p>
            We validated the problem by spending weeks on multiple construction
            sites and tried building technology to solve the problems. Making
            plenty of mistakes along the way, we’ve got some fantastic clients
            now and a long way to go. So excited!
          </p>

          <p>
            <strong>
              - Iesh Dixit
              <br />
              Founder, CEO @ Powerplay
            </strong>
          </p>
        </div>
      </div>
    </section>
    <section className="stats-home">
      <div className="container">
        <div className="flex-row">
          <div className="col-4 col">
            <div className="single-stat">
              <h4>
                <Counter start={0} end={800} duration={0.1} />+
              </h4>
              <p>Total Projects Managed</p>
            </div>
          </div>
          <div className="col-4 col">
            <div className="single-stat">
              <h4>
                <Counter start={0} end={200} duration={0.25} />+
              </h4>
              <p>Hours Saved Each Week</p>
            </div>
          </div>
          <div className="col-4 col">
            <div className="single-stat">
              <h4>
                <Counter start={0} end={90} duration={1} />%
              </h4>
              <p>Report Greater Visibility</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div className="dreams-main pad100">
        <div className="container">
          <div className="flex-row">
            <div className="col offset-1" style={{ width: '100%' }}>
              <h2 className="heading">Making dreams possible</h2>

              <div className="flex-row">
                <div className="col-5 col">
                  <div className="single-about">
                    <img src="/img/mission-icon.svg" alt="Our mission" />
                    <h3>Our Mission</h3>
                    <p>
                      We’re building tools that will bring the speed of software
                      development to infrastructure development.
                    </p>
                  </div>
                </div>
                <div className="col-5 col">
                  <div className="single-about">
                    <img src="/img/values-icon.svg" alt="Our Values" />
                    <h3>Our Values</h3>
                    <p>
                      We believe in growth and quick consistent improvements.
                      We’re committed to bringing the future of construction to
                      the present.
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-row">
                <div className="col-5 col">
                  <div className="single-about">
                    <img src="/img/promise-icon.svg" alt="Our Promise" />
                    <h3>Our Promise</h3>
                    <p>
                      We build for India — we’re boosting infrastructure
                      development by digitising the construction industry
                      through innovation and creativity.
                    </p>
                  </div>
                </div>
                <div className="col-6 col offset-1">
                  <div className="single-about-img">
                    <img src="/img/about-img.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="team-main pad100">
      <div className="container">
        <h2 className="heading inner-heading text-center">Meet Our Team</h2>
        <div className="flex-row">
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/iesh.png" alt="" />
              <h3>Iesh Dixit</h3>
              <h5>CEO &amp; Cofounder</h5>
              <p>
                Rap lover, particularly Eminem &amp; Kendrick Lamar,
                bibliophile, &amp; fitness enthusiast
              </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/shubham.png" alt="" />
              <h3>Shubham Goyal</h3>
              <h5>CTO &amp; Cofounder</h5>
              <p>Consumes biographies and enjoys daily workouts at the gym </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/manish.png" alt="" />
              <h3>Manish Prasad</h3>
              <h5>Founding Team</h5>
              <p>
                Huge fun of F1, loves reading &amp; learning about Indian
                history, movie buff{' '}
              </p>
            </div>
          </div>

          <div className="col col-3">
            <div className="single-team">
              <img src="/img/anshul.png" alt="" />
              <h3>Anshul Gupta</h3>
              <h5>Founding Team</h5>
              <p>
                Poker enthusiast who loves hiking &amp; trekking on his travels
              </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/archana.png" alt="" />
              <h3>Archana Ashok</h3>
              <h5>VP-Talent Aquisition &amp; PeopleX</h5>
              <p>
                Consumes TEDTalks &amp; goes on frequent treks &amp; explore the
                unexplored
              </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/dummy-profile.png" alt="" />
              <h3>Aakansha</h3>
              <h5>Product Manager Lead </h5>
              <p>
                Binges TV shows, loves being creative with arts and craft
                projects
              </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/yash.png" alt="" />
              <h3>Yash Khandelwal</h3>
              <h5>Product designer</h5>
              <p>Reads sci-fi &amp; fantasy books, loves photography</p>
            </div>
          </div>

          <div className="col col-3">
            <div className="single-team">
              <img src="/img/dummy-profile.png" alt="" />
              <h3>Vibhanshu Sharma</h3>
              <h5>Android developer</h5>
              <p>
                Devours non-fiction &amp; spiritual books, enjoys working out
              </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/dummy-profile.png" alt="" />
              <h3>Dhaval Chauhan</h3>
              <h5>Product Manager</h5>
              <p>Hip-hop dancer who loves videogames — huge FIFA enthusiast</p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/kunal.png" alt="" />
              <h3>Kunal Das</h3>
              <h5>Android developer</h5>
              <p>Spends a lot of time watching movies and playing videogames</p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/snayam.png" alt="" />
              <h3>Sanyam Parashar</h3>
              <h5>Growth PM</h5>
              <p>
                Loves socialising, playing badminton (very well), and
                motorsports
              </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/faizan.png" alt="" />
              <h3>Mohammad Faizan Azim</h3>
              <h5>Frontend developer</h5>
              <p>Footballer, music lover — especially rap</p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/ishank.png" alt="" />
              <h3>Ishank Nijhawan</h3>
              <h5>Android developer</h5>
              <p>
                Captures moments through photos and visualizes life with his
                paintings
              </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/mithilesh.png" alt="" />
              <h3>Mithilesh Parmar</h3>
              <h5>Flutter/iOS Developer</h5>
              <p>
                Enjoys travelling to check out amazing sights across the world
              </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/dummy-profile.png" alt="" />
              <h3>Akash Ranjan</h3>
              <h5>Customer Success Manager</h5>
              <p>
                Plays soccer in the evenings &amp; travels around the world
                during his vacations
              </p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/dummy-profile.png" alt="" />
              <h3>Harish</h3>
              <h5>Community Manager</h5>
              <p>Has Spotify on all day long because he loves music so much</p>
            </div>
          </div>
          <div className="col col-3">
            <div className="single-team">
              <img src="/img/dummy-profile.png" alt="" />
              <h3>Saurabh Dhani</h3>
              <h5>Manager HR</h5>
              <p>
                Loves playing old Bollywood songs on the guitar &amp; keeping
                himself fit
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="pad100">
      <div className="container">
        <h2 className="heading text-center">Our Investors</h2>
        <div className="flex-row">
          <div className="col col-4">
            <div className="single-investor">
              <img src="/img/surge.png" alt="surge" />
            </div>
          </div>
          <div className="col col-4">
            <div className="single-investor">
              <img src="/img/accel.png" alt="accent" />
            </div>
          </div>
          <div className="col col-4">
            <div className="single-investor">
              <img src="/img/india-quotient.png" alt="india-quotient" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="bg-lightblue">
      <CareerBlock />
    </section>
    <section className="pad100">
      <div className="container">
        <div className="flex-row align-items-center">
          <div className="col col-5">
            <div className="office-text">
              <h2 className="heading">Our Office</h2>
              <p>
                Our office is based in Bengaluru, India’s tech centre. We’re a
                distributed team, with several team members working remotely to
                add value to our clients’ projects.
              </p>
              <div className="office-location">
                <h3>Bengaluru, India</h3>
                <p>
                  No. 1498, 19th Main, Sector–1, HSR Layout,
                  <br />
                  Bangalore – 560102
                </p>
              </div>
            </div>
          </div>
          <div className="col col-7">
            <div className="office-imgs">
              <div className="single-office-image">
                <img src="/img/office-1.png" alt="office" />
              </div>
              <div className="single-office-image">
                <img src="/img/office-2.png" alt="office" />
                <img src="/img/office-3.png" alt="office" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="pad100 bg-lightblue">
      <SuggestedBlogs posts={posts} />
    </section>
  </Layout>
);

About.propTypes = {
  data: PropTypes.shape({
    blog: PropTypes.shape({
      posts: PropTypes.arrayOf(
        PropTypes.shape({
          fields: PropTypes.shape({
            slug: PropTypes.string.isRequired,
          }).isRequired,
          frontmatter: PropTypes.shape({
            title: PropTypes.string.isRequired,
            featuredImage: PropTypes.string.isRequired,
          }).isRequired,
          excerpt: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }).isRequired,
  }).isRequired,
};

export default About;

export const pageQuery = graphql`
  query AboutQuery {
    blog: allMarkdownRemark(limit: 3) {
      posts: nodes {
        frontmatter {
          date(fromNow: true)
          title
          author
          featuredImage
        }
        excerpt
        id
        fields {
          slug
        }
      }
    }
  }
`;
